<!--
 Created by Daniil Vat. on 18/2/2021
 Copyright © 2021 Curriculum Ltd. All rights reserved.
-->
<div class="wrapper">
  <div class="panel" [ngClass]="{ open: isShowed, error: isError }" (clickOutside)="closeDropDown()">
    <div class="custom-select" [class.disabled]="isDisabled" (click)="toggleDropdown()" [attr.data-titleName]="title">
      <div class="content" fxLayoutAlign="space-between center" fxLayout="row">
        <div class="custom-select__trigger mat-h3 text">
          <div class="text" [class.disabled]="isDisabled">
            <div header class="mat-h2 full-width paper-title m-b-0" [class.text-with-subtitle]="subTitle">
              {{title}}
              <div class="subtitle" *ngIf="subTitle">{{subTitle}}</div>
            </div>
          </div>
        </div>
        <div fxLayoutAlign="end center" fxLayout="row">
          <div class="panel-status" *ngIf="status && !isAbsent" [class]="statusClass">{{statusText}}</div>
          <div class="panel-status" *ngIf="isAbsentLogic && isAbsent" [class]="'absent'">Absent</div>
          <curr-button class="panel-absent-btn m-r-16" *ngIf="isAbsentLogic && !isAbsent && isAbsentBtnShow" variant="outlined" (click)="absentBtnAction($event)">Mark as Absent</curr-button>
          <div class="arrow-wrapper m-r-24 m-l-8"><span class="arrow"></span></div>
        </div>
      </div>
    </div>

    <div *ngIf="isShowed" class="options" [@enterAnimation]>
      <div class="divider"></div>
      <div class="container">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
